import ServiceBase from "base/baseService"

export default class MomentoService extends ServiceBase {

    title = "Momento"
    pluralTitle = "Momentos"
    url = '/cadastro/outros/momento'
    frontUrl = '/cadastro/outros/momento'
    frontUrlList = '/cadastro/outros/momentolist'
    primaryKey = 'codigo_mom'

    prepareToFront(data = {}) {
        data.codigo_mom = data?.codigo_mom || ''
        data.descricao_mom = data?.descricao_mom || ''
        return data
    }

    prepareToSave({ data }) {
        if ('meta' in data) delete data.meta
        return data
    }

}
